import type { Feature } from 'geojson'
import { getDeterministicColor } from '../../utils/mapDrawHandle'

export const getColor = (feature: Feature) => {
  if (feature?.properties?.type === 'perimeter') {
    return 'black'
  }

  return (
    feature?.properties?.color ??
    getDeterministicColor(feature?.properties?.id || feature?.properties?.name || Math.random())
  )
}
